module.exports = __webpack_public_path__ + "img/samplering@2x.870558a.webp";